import { render, staticRenderFns } from "./HomeAdmin.vue?vue&type=template&id=66c51237&scoped=true&"
import script from "./HomeAdmin.vue?vue&type=script&lang=js&"
export * from "./HomeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./HomeAdmin.vue?vue&type=style&index=0&id=66c51237&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c51237",
  null
  
)

export default component.exports